import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';

export const ThreeDSContainer = styled.div(() =>
  mq({
    width: '100%',
    height: '500px',
  }),
);

export const IFrameContainer = styled.iframe(() =>
  mq({
    width: '100%',
    height: '500px',
  }),
);
